
<div class="sc-textarea">
  <div>
    <label class="input-label" *ngIf="scLabel">
      {{ scLabel }}
      <span class="sc-required sc-required-star"></span>
    </label>
  </div>

<textarea [(ngModel)]="value"
          [disabled]="isDisabled"
          [readOnly]= "scIsReadonly"
          class="sc-text-area"
          [rows]="scRows"
          [cols]="scCols"
          (blur)="onBlur($event)"
          [attr.placeholder]="scPlaceholder"
          (ngModelChange)="onModelChange($event)"
          [style.width]="scWidth"></textarea>
</div>
<p class="sc-error-message" *ngIf="!scHideValidationMessage && !isValid">{{ validationMessage }}</p>

